import { Navigate, useRoutes } from 'react-router-dom';
import LayoutIndex from '@/layout';
import Home from '@/views/home';
import About from '@/views/about';
import News from '@/views/news';
import Login from '@/views/login';
import Contact from '@/views/contact';
import Document from '@/views/documents';
import Ota from '../views/production/ota';
import Diag from '../views/production/diag';
import BasicSoftware from '../views/production/basic-software';
import ELearn from '../views/production/e-learn';
import Test from '../views/production/test';
import Tool from '../views/production/tool';

// * 导入所有router
const requireContext = require.context('@/articles/news/', true, /\.md$/);
const requireProductsMd = require.context('@/articles/product/', true, /\.md$/);

// * 处理路由
export const routerNews = [];

requireContext.keys().forEach((key) => {
  routerNews.push({
    path: '/news/document-' + key.slice(key.lastIndexOf('/') + 1).replace('.md', ''),
    element: <Document url={`news/${key.replace('./', '')}`} />,
    meta: {
      key
    },
  });
});

export const productsRouterArray = [];
requireProductsMd.keys().forEach((key) => {
  productsRouterArray.push({
    path: key.replace('./', '').replace('.md', ''),
    element: <Document url={`product/${key.replace('./', '')}`} />,
    meta: {
      key
    },
  });
});

export const rootRouter = [
  {
    path: '/',
    element: <Navigate to="/home" />,
    meta: {
      key: 'index'
    },
  },
  {
    path: '/',
    element: <LayoutIndex />,
    meta: {
      key: 'index'
    },
    children: [
      {
        path: '/home',
        element: <Home />,
        meta: {
          key: 'home'
        }
      },
      {
        path: '/about',
        element: <About />,
        meta: {
          key: 'about'
        },
      },
      {
        path: '/news',
        element: <News />,
        meta: {
          key: 'news'
        },
      },
      {
        path: '/news',
        meta: {
          key: 'news'
        },
        children: routerNews,
      },
      {
        path: '/product',
        // element: <Products />,
        meta: {
          key: 'product'
        },
        children: [{
          path: 'ota',
          element: <Ota />,
          meta: {
            key: 'ota'
          },
        },{
          path: 'diagnosis',
          element: <Diag />,
          meta: {
            key: 'diag'
          },
        },{
          path: 'basic',
          element: <BasicSoftware />,
          meta: {
            key: 'basic'
          },
        },{
          path: 'eLearn',
          element: <ELearn />,
          meta: {
            key: 'eLearn'
          },
        },{
          path: 'test',
          element: <Test />,
          meta: {
            key: 'test'
          },
        },{
          path: 'tool',
          element: <Tool />,
          meta: {
            key: 'tool'
          },
        }]
      },
      {
        path: '/login',
        element: <Login />,
        meta: {
          key: 'login'
        }
      },
      {
        path: '/download',
        element: <About />,
        meta: {
          key: 'download'
        }
      },
      {
        path: '/contact',
        element: <Contact />,
        meta: {
          key: 'contact'
        }
      },
    ]
  },
  {
    path: '*',
    element: <Navigate to="/404" />
  }
];

const Router = () => {
  const routes = useRoutes(rootRouter);
  return routes;
};

export default Router;
